// extracted by mini-css-extract-plugin
export var icon = "social-module--icon--33e8b";
export var section_sns_official_icon = "social-module--section_sns_official_icon--efa50";